<template>
    <v-card elevation="10" class="doc-panel pa-2" v-if="document">
        <c-column-header
            class  = "primary"
            :label = "document.name"
        >
            <template v-slot:filter>
                <div class="v-flex" style="margin-top: -2px">
                    <v-switch
                        v-model = "collective"
                        color   = "white"
                        class   = "mt-0 pt-1"
                        :ripple = "false"
                        hide-details
                        @change = "onChange"
                    >
                        <template v-slot:label>
                            <div style="width: 300px">
                                <span v-if="collective" class="white--text">Dokument ist allen Anlagen zugeordnet</span>
                                <span v-if="!collective"  class="white--text">Dokument ist Anlage {{ document.unitName }} zugeordnet</span>
                            </div>
                        </template>
                    </v-switch>
                    <c-toolbar-button
                        icon   = "mdi-close"
                        color  = "white"
                        size   = "22"
                        @click = "onClose"
                        tooltip="Dokument schließen"
                    />
                </div>
            </template>
        </c-column-header>
        <c-dms-viewer
            class     = "w-100 white mt-1"
            style     = "height: calc(100% - 35px)"
            :document = "documentId"
        />
    </v-card>
</template>

<script>

import CColumnHeader  from "@/modules/core/components/utils/CColumnHeader.vue";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import Inc from "@/modules/inc/service/Inc";
import CDmsViewer from "@/modules/dms/viewer/CDmsViewer.vue";

export default {
    name: "CDmsViewerCard",

    components: {
        CDmsViewer,
        CToolbarButton,
        CColumnHeader
    },

    props: {
        value: {

        },

        document: {

        }
    },

    data: () => ({
        refresh: 0,
        collective: null,
        documentId: null
    }),

    computed: {
        unit() {
            return this.$store.getters.site;
        }
    },

    watch: {
        document() {
            if (this.document) {
                this.$nextTick(() => {
                    this.documentId = this.document.id;
                    this.collective = this.document.unitName === null;
                })
            }
        }
    },

    methods:  {
        onClose () {
            this.$emit("input", false);
            this.$emit("close");
        },

        onChange () {
            if (this.collective) {
                Inc.document.assignToUnit(this.document.id, 0, () => {
                    this.document.unitName = null;
                    this.$emit("assigned", {
                        document: this.document,
                        unit    : null
                    });
                })
            }  else {
                Inc.document.assignToUnit(this.document.id, this.unit.id, () => {
                    this.document.unitName = this.unit.fabricNo;
                    this.$emit("assigned", {
                        document: this.document,
                        unit    : this.unit
                    });
                })
            }
        },
    }
}
</script>

<style scoped>

.doc-panel {
    width: calc(50% - 70px);
    height: 705px;
    position: absolute;
    z-index: 10;
    top: 248px;
    right: calc(25% + 30px);
    background-color: white;
}
</style>